import React from 'react';
import { useLocation } from 'react-router-dom';
import { invoiceTabEnums, invoiceTabTypes } from './constants';
import { InvoiceFilters, InvoiceSelectedFilters } from './invoiceFilters';
import { TabSwitcher } from 'components';
import { InvoicebleApt } from './InvoicebleApt';
import { OpenInvoice } from './openInvoice';
import { CompletedInvoices } from './completedInvoices';
import { PendingInvoices } from './pendingInvoices';

export const Invoices = () => {
    const location = useLocation();
    const info = location?.state;

    const checkTableType =
        info?.tabType === invoiceTabEnums?.INVOICEABLE_APPT
            ? invoiceTabEnums?.INVOICEABLE_APPT
            : info?.tabType === invoiceTabEnums?.PENDING
              ? invoiceTabEnums?.PENDING
              : info?.tabType === invoiceTabEnums?.OPEN
                ? invoiceTabEnums?.OPEN
                : info?.tabType === invoiceTabEnums?.COMPLETED
                  ? invoiceTabEnums?.COMPLETED
                  : invoiceTabEnums?.INVOICEABLE_APPT;

    return (
        <div>
            <div className="invoice-filters-wrapper" style={{ marginBottom: 12 }}>
                <TabSwitcher list={invoiceTabTypes} defaultType={invoiceTabEnums?.INVOICEABLE_APPT} />
                <div className="invoice-filter-box">
                    <InvoiceFilters />
                </div>
            </div>

            <InvoiceSelectedFilters />

            {checkTableType === invoiceTabEnums?.INVOICEABLE_APPT && <InvoicebleApt />}

            {checkTableType === invoiceTabEnums?.PENDING && <PendingInvoices />}

            {checkTableType === invoiceTabEnums?.OPEN && <OpenInvoice />}

            {checkTableType === invoiceTabEnums?.COMPLETED && <CompletedInvoices />}
        </div>
    );
};
